import React from 'react';

interface TaskObserversProps {
    fill?: string;
}

export const TaskObservers = ({ fill }: TaskObserversProps) => {
    return (
        <>
            <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_5268_12455)">
                    <g clipPath="url(#clip1_5268_12455)">
                        <path
                            d="M11.997 5.09248C11.9869 4.93 11.9447 4.77113 11.873 4.62499C11.8013 4.47886 11.7013 4.34835 11.579 4.24098L8.13799 1.12648C6.10849 -0.649524 4.03699 0.059976 3.22399 0.683476L2.74499 1.05098L5.62499 3.61948L0.0369873 10.009L2.29599 11.9835L7.86349 5.61648L9.26899 6.86998C9.39229 6.97847 9.53592 7.0614 9.69154 7.11393C9.84715 7.16646 10.0117 7.18755 10.1755 7.17598C10.3394 7.16527 10.4995 7.12225 10.6466 7.04939C10.7938 6.97654 10.9251 6.87529 11.033 6.75148L11.691 5.99848C11.7994 5.87523 11.8823 5.73169 11.9348 5.57616C11.9874 5.42064 12.0085 5.25623 11.997 5.09248ZM7.47349 1.87298L9.61649 3.81298L8.62049 4.95148L4.39049 1.17848C5.04449 0.923976 6.19899 0.758476 7.47349 1.87298ZM2.20099 10.5725L1.44799 9.91448L6.37149 4.28548L7.11749 4.95098L2.20099 10.5725ZM10.938 5.34048L10.28 6.09348C10.2363 6.14325 10.1746 6.17364 10.1085 6.17798C10.0766 6.18066 10.0446 6.17695 10.0142 6.16708C9.98379 6.15721 9.95568 6.14136 9.93149 6.12048L9.36749 5.61748L10.3585 4.48448L10.9145 4.98798C10.9394 5.0094 10.9599 5.03559 10.9746 5.06501C10.9893 5.09442 10.998 5.12647 11.0002 5.15929C11.0024 5.19211 10.998 5.22504 10.9873 5.25615C10.9767 5.28726 10.9599 5.31593 10.938 5.34048Z"
                            fill="#818998"
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_5268_12455">
                        <rect width="12" height="12" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_5268_12455">
                        <rect width="12" height="12" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </>
    );
};
